import React, { useState, useCallback, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles, Theme } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import SearchIcon from "@material-ui/icons/Search";
import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { useHistory } from "react-router";
import ListSubheader from "@material-ui/core/ListSubheader";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import AddIcon from "@material-ui/icons/Add";
import IconButton from "@material-ui/core/IconButton";
import { useSelector, useDispatch } from "react-redux";
import useMedia from "use-media";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import FavoriteIcon from "@material-ui/icons/Favorite";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import CreateIcon from "@material-ui/icons/Create";

import {
  fetchAsyncGetMenu,
  selectMenu,
  selectTargetMenu,
  fetchAsyncDeleteFavoriteMenu,
  fetchAsyncGetFavoriteMenu,
  fetchAsyncCreateFavoriteMenu,
  selectFavoriteMenu,
  fetchAsyncGetLastRecord,
  selectOriginalMenu,
  fetchAsyncGetLastOriginalRecord,
  editOriginalMenu,
  selectSelectedMenuCategory,
  initialState,
} from "../home/homeSlice";

import { fetchAsyncLoginUser, selectLoginUser } from "../auth/authSlice";

import { FAVORITE_MENU, MENU, ORIGINAL_MENU } from "../../types/types";

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    position: "fixed",
    width: "100%",
    padding: theme.spacing(2, 2, 2, 2),
    margin: 0,
    boxSizing: "border-box",
    zIndex: 2,
    backgroundColor: "#f1f9ff",
    maxWidth: "66.667%",
    minHeight: theme.spacing(8),
  },
  paperRes: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    position: "fixed",
    justifyContent: "space-between",
    width: "100%",
    padding: theme.spacing(2, 2, 2, 2),
    margin: 0,
    boxSizing: "border-box",
    zIndex: 2,
    backgroundColor: "#f1f9ff",
    minHeight: theme.spacing(8),
  },
  search: {
    borderRadius: 30,
    border: "1px solid #F1F9FF",
    display: "flex",
    width: "80%",
    alignItems: "center",
  },
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    position: "relative",
    overflow: "auto",
    paddingBottom: 0,
  },

  color: {
    color: "#2699FB",
  },
  listContainer: {
    paddingLeft: theme.spacing(1),
    backgroundColor: "#fff",
    borderRadius: 5,
    marginBottom: theme.spacing(8),
    marginTop: theme.spacing(10),
  },
  favoriteUl: {
    backgroundColor: "inherit",
    padding: 0,
  },
  ul: {
    backgroundColor: "inherit",
    padding: 0,
    marginBottom: theme.spacing(7),
  },
  listSection: {
    backgroundColor: "inherit",
  },
  itemHeader: {
    backgroundColor: "#F1F9FF",
    fontWeight: "bold",
    color: "#2699FB",
  },
  gridContainer: {
    zIndex: 3,
    height: "100vh",
  },
  favorite: {
    paddingRight: theme.spacing(1),
    color: "#dbedff",
  },
  favoriteColor: {
    paddingRight: theme.spacing(1),
    color: "red",
  },
  favoriteSection: {
    color: "#0066cc",
    fontWeight: "bold",
    backgroundColor: "#F1F9FF",
  },
  searchIcon: {
    padding: theme.spacing(1),
  },
  addMenu: {
    textAlign: "center",
    display: "flex",
    justifyContent: "flex-end",
  },
  addMenuBtn: {
    fontSize: 10,
    padding: theme.spacing(1),
  },
  editIcon: {
    paddingLeft: 0,
  },
  listItem: {
    borderBottom: "1px solid #dfdfdf",
    "&:last-child": {
      borderBottom: "none",
    },
  },
}));

const MenuList: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const menu = useSelector(selectMenu);
  const isWide = useMedia({ minWidth: "600px" });
  const favoriteMenu = useSelector(selectFavoriteMenu);
  const loginUser = useSelector(selectLoginUser);
  const originalMenu = useSelector(selectOriginalMenu);
  const selectedMenuCategory = useSelector(selectSelectedMenuCategory);
  // const selectedMenuCategory = useSelector(selectSelectedMenuCategoryName);
  const [filterFavoriteMenu, setTargetCategoryMenu] = useState(
    initialState.favoriteMenu
  );
  //各menuのfilter用（検索した結果が入る）
  const [filterTargetCategoryMenu, setFilterTargetCategoryMenu] = useState(
    initialState.menu
  );

  const [searchWord, setSearchWord] = useState("");
  //検索フィールド入力時
  const handleInputSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    //ローカルstateへ検索ワードを保存
    setSearchWord(e.target.value);
    //メニューから検索
    filterMenuList(e);
  };
  //選択したmenuをstate selectMenuに格納し、画面遷移
  const handleSelectMenu = async (item: MENU) => {
    const para = { id: loginUser.id, menu_id: item.id };
    await dispatch(selectTargetMenu(item));
    await dispatch(fetchAsyncGetLastRecord(para));
    await history.push("/home/add/record");
  };

  //オリジナルメニューを選択
  const handleSelectOriginalMenu = async (item: MENU) => {
    const para = { id: loginUser.id, menu_id: item.id };
    await dispatch(selectTargetMenu(item));
    await dispatch(fetchAsyncGetLastOriginalRecord(para));
    await history.push("/home/add/record");
  };

  //選択したメニューをお気に入り登録
  const handleFavoriteMenu = useCallback(
    (id: number) => {
      dispatch(fetchAsyncCreateFavoriteMenu(id));
    },
    [dispatch]
  );
  //選択したメニューをお気に入りから削除
  const handleDeleteFavoriteMenu = useCallback(
    (id: number) => {
      dispatch(fetchAsyncDeleteFavoriteMenu(id));
    },
    [dispatch]
  );
  //お気に入りメニュー選択時
  //favoriteMenuとデータの型が異なるため、menuから該当のメニューを探し、そのデータを与える
  const handleSelectFavoriteMenu = async (id: number) => {
    const targetMenu = menu.filter((item) => item.id === id);
    const para = { id: loginUser.id, menu_id: id };
    await dispatch(selectTargetMenu(targetMenu[0]));
    await dispatch(fetchAsyncGetLastRecord(para));
    await history.push("/home/add/record");
  };
  //お気にいり削除（すでに登録されているメニューを再度押した場合）
  const handleSelectDeleteFavoriteMenu = useCallback(
    (id: number) => {
      const targetMenu = favoriteMenu.filter((item) => item.menu_id === id);
      dispatch(fetchAsyncDeleteFavoriteMenu(targetMenu[0].id));
    },
    [dispatch, favoriteMenu]
  );
  //オリジナルメニュー作成
  const handleCreateMenu = useCallback(async () => {
    await history.push("/home/create/menu");
  }, [history]);

  const handleEditOriginalMenu = useCallback(
    async (item: ORIGINAL_MENU) => {
      await dispatch(editOriginalMenu(item));
      await history.push("/home/create/menu");
    },
    [dispatch]
  );

  const filterMenuList = (e: React.ChangeEvent<HTMLInputElement>) => {
    //検索ワードに一致するものをfiterへセット
    //renderItemにて、検索欄に文字が入力されている場合、filterPartChestを表示させる
    const filterMenu = menu.filter((item) => {
      return item.title.search(e.target.value) !== -1;
    });

    setFilterTargetCategoryMenu(filterMenu);
  };

  const filterFavoriteList = () => {
    const filterMenu = favoriteMenu.filter((item) => {
      return item.menu_part === selectedMenuCategory.part_name;
    });
    setTargetCategoryMenu(filterMenu);
  };

  const backPage = useCallback(() => {
    history.push("/home/menu/category");
  }, [history]);

  const renderFavoriteMenu = () => {
    if (filterFavoriteMenu.length > 0 && searchWord.length === 0) {
      return filterFavoriteMenu.map((item: FAVORITE_MENU) => (
        <ListItem key={`item-${item.id}`} className={classes.listItem}>
          <FavoriteIcon
            className={classes.favorite}
            onClick={() => {
              handleDeleteFavoriteMenu(item.id);
            }}
          />
          <ListItemText
            primary={`${item.menu_title}`}
            className={classes.color}
          />
          <AddIcon
            className={classes.color}
            onClick={() => {
              handleSelectFavoriteMenu(item.menu_id);
            }}
          />
        </ListItem>
      ));
    }
  };

  const renderSelectMenu = () => {
    if (menu.length > 0 && searchWord.length === 0) {
      return menu.map((item: MENU) => (
        <ListItem key={`menu-${item.id}`} className={classes.listItem}>
          {/* お気にり済みかどうかでアイコンの表示を変更 */}
          {favoriteMenu.some((fav) => fav.menu_id === item.id) ? (
            <FavoriteIcon
              className={classes.favorite}
              onClick={() => {
                handleSelectDeleteFavoriteMenu(item.id);
              }}
            />
          ) : (
            <FavoriteBorderIcon
              className={classes.favorite}
              onClick={() => {
                handleFavoriteMenu(item.id);
              }}
            />
          )}
          <ListItemText primary={`${item.title}`} className={classes.color} />
          <AddIcon
            className={classes.color}
            onClick={() => {
              handleSelectMenu(item);
            }}
          />
        </ListItem>
      ));
    }
    if (menu.length > 0 && searchWord.length > 0) {
      // 検索欄にワードが入っている場合、検索結果を表示
      return filterTargetCategoryMenu.map((item: MENU) => (
        <ListItem key={`filtermenu-${item.id}`} className={classes.listItem}>
          {/* お気にり済みかどうかでアイコンの表示を変更 */}
          {favoriteMenu.some((fav) => fav.menu_id === item.id) ? (
            <FavoriteIcon
              className={classes.favorite}
              onClick={() => {
                handleSelectDeleteFavoriteMenu(item.id);
              }}
            />
          ) : (
            <FavoriteBorderIcon
              className={classes.favorite}
              onClick={() => {
                handleFavoriteMenu(item.id);
              }}
            />
          )}
          <ListItemText primary={`${item.title}`} className={classes.color} />
          <AddIcon
            className={classes.color}
            onClick={() => {
              handleSelectMenu(item);
            }}
          />
        </ListItem>
      ));
    }
  };

  const renderOriginalMenu = () => {
    if (
      originalMenu.length > 0 &&
      searchWord.length === 0 &&
      selectedMenuCategory.part_name === "オリジナルメニュー"
    ) {
      // 検索欄にワードが入っている場合、検索結果を表示
      return originalMenu.map(
        (item) =>
          item.id !== 0 && (
            <ListItem
              key={`originalitem-${item.id}`}
              className={classes.listItem}
            >
              <IconButton
                className={classes.editIcon}
                onClick={() => handleEditOriginalMenu(item)}
              >
                <CreateIcon />
              </IconButton>
              <ListItemText
                primary={`${item.title}`}
                className={classes.color}
              />
              <AddIcon
                className={classes.color}
                onClick={() => {
                  handleSelectOriginalMenu(item);
                }}
              />
            </ListItem>
          )
      );
    }
  };

  useEffect(() => {
    //メニューリストが取得できていない場合、取得
    if (menu.length === 1) {
      dispatch(fetchAsyncGetMenu(selectedMenuCategory.part));
      dispatch(fetchAsyncGetFavoriteMenu());
    }
    if (loginUser.id === 0) {
      dispatch(fetchAsyncLoginUser());
    }
  }, [dispatch, menu, loginUser]);

  useEffect(() => {
    filterFavoriteList();
  }, [favoriteMenu]);

  useEffect(() => {
    selectedMenuCategory.title.length === 0 && history.push("/home");
  }, [history]);

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        className={classes.gridContainer}
        component={Paper}
        elevation={6}
        square
      >
        <div className={isWide ? classes.paper : classes.paperRes}>
          <div>
            <ArrowBackIcon onClick={backPage} />
          </div>
          {selectedMenuCategory.part_name !== "オリジナルメニュー" && (
            <Paper className={classes.search}>
              <SearchIcon className={classes.searchIcon} />
              <InputBase
                placeholder="Search Menu"
                fullWidth
                onChange={handleInputSearch}
              />
            </Paper>
          )}
          {selectedMenuCategory.part_name === "オリジナルメニュー" && (
            <div className={classes.addMenu}>
              <IconButton
                className={classes.addMenuBtn}
                onClick={handleCreateMenu}
              >
                <BorderColorIcon />
                メニューを作成
              </IconButton>
            </div>
          )}
        </div>
        <div className={classes.listContainer}>
          {/* リスト表示 */}
          <List className={classes.root} subheader={<li />}>
            <li key={"selectMenu-key"} className={classes.listSection}>
              {searchWord.length === 0 &&
                filterFavoriteMenu.length > 0 &&
                selectedMenuCategory.part_name !== "オリジナルメニュー" && (
                  <ul className={classes.favoriteUl}>
                    <ListSubheader className={classes.favoriteSection}>
                      お気に入り
                    </ListSubheader>
                    {renderFavoriteMenu()}
                  </ul>
                )}
              <ul className={classes.ul}>
                <ListSubheader className={classes.itemHeader}>
                  {selectedMenuCategory.part_name}
                </ListSubheader>
                {renderSelectMenu()}
                {renderOriginalMenu()}
              </ul>
            </li>
          </List>
        </div>
      </Grid>
    </Grid>
  );
};

export default MenuList;
